export interface ResolveSupabaseUrlOptions {
  configuredUrl?: string;
  windowOrigin?: string;
}

/** Production: use portal origin so API goes through same-host nginx proxy. */
export function resolveSupabaseUrl(
  envConfiguredUrl: string,
  options: ResolveSupabaseUrlOptions = {},
): string {
  const configured = options.configuredUrl ?? envConfiguredUrl;

  if (configured && configured !== 'SAME_ORIGIN' && configured !== '/') {
    return configured.replace(/\/$/, '');
  }

  const origin = options.windowOrigin
    ?? (typeof window !== 'undefined' ? window.location.origin : undefined);

  if (origin) {
    return origin.replace(/\/$/, '');
  }

  return '';
}
